/* eslint-disable react/no-unstable-nested-components */
import { FC } from 'react';
import { Button, Icon, Popover, Text } from '@livechat/design-system-react-components';
import { GridDots as GridDotsIcon } from '@livechat/design-system-icons';

import { ProductListItem } from './dropdown-items/ProductListItem';

import {
  buttonStyles,
  productListContainer,
  mainContainerStyles,
  headerStyles,
  popoverStyles,
} from './styles';

export const ProductDropdown: FC = () => {
  const productList = [
    { product: 1, label: 'Connect with customers', url: import.meta.env.VITE_APP_LC_LANDING },
    {
      product: 4,
      label: 'Automate customer service with AI',
      url: import.meta.env.VITE_APP_CB_LANDING,
    },
    {
      product: 2,
      label: 'Support customers with tickets',
      url: import.meta.env.VITE_APP_HD_LANDING,
    },
    {
      product: 3,
      label: 'Improve support with self-service',
      url: import.meta.env.VITE_APP_KB_LANDING,
    },
    {
      product: 5,
      label: 'Enhance websites with widgets',
      url: import.meta.env.VITE_APP_OW_LANDING,
    },
    {
      product: 7,
      label: 'Improve team communication',
      url: import.meta.env.VITE_APP_TC_LANDING,
    },
    {
      product: 6,
      label: 'Build and monetize automation tools',
      url: import.meta.env.VITE_APP_TP_LANDING,
    },
    {
      product: 8,
      label: 'Perfect for solution providers',
      url: import.meta.env.VITE_APP_PP_LANDING,
    },
  ];

  return (
    <Popover
      placement="bottom-end"
      css={popoverStyles}
      triggerRenderer={() => (
        <Button
          icon={<Icon kind="primary" size="large" source={GridDotsIcon} />}
          kind="text"
          css={buttonStyles}
          data-testid="products-dropdown"
        />
      )}
    >
      <div css={mainContainerStyles} data-testid="main-products">
        <Text size="xs" css={headerStyles}>
          TEXT PORTFOLIO
        </Text>
        <ul css={productListContainer}>
          {productList.map(({ url, product, label }) => (
            <li key={product}>
              <ProductListItem url={url} product={product} label={label} />
            </li>
          ))}
        </ul>
      </div>
    </Popover>
  );
};
